// extracted by mini-css-extract-plugin
module.exports = {"primary":"primarybutton_primary__3odfJ","secondary":"primarybutton_secondary__NpYv4","flex":"primarybutton_flex__LgGCG"};